<script lang="ts">
  import { toasts } from '../lib/toast';
</script>

{#if $toasts.length}
  <div class="toasts" role="status" aria-live="polite">
    {#each $toasts as t (t.id)}
      <div class="toast">{t.message}</div>
    {/each}
  </div>
{/if}

<style>
  .toasts { position: fixed; left: 50%; bottom: calc(var(--safe-bottom, 0px) + var(--space-6)); transform: translateX(-50%); z-index: var(--z-toast, 60); display: flex; flex-direction: column; gap: var(--space-2); width: min(92vw, 420px); pointer-events: none; }
  .toast { padding: var(--space-3) var(--space-4); border-radius: var(--radius-md); background: color-mix(in srgb, var(--surface) 92%, transparent); border: 1px solid var(--line-strong); color: var(--text); font-size: var(--fs-sm); line-height: 1.4; box-shadow: 0 12px 40px -12px color-mix(in srgb, var(--bg) 90%, black); backdrop-filter: blur(10px); animation: rise 0.18s ease; }
  @keyframes rise { from { opacity: 0; transform: translateY(6px); } to { opacity: 1; transform: translateY(0); } }
  @media (prefers-reduced-motion: reduce) { .toast { animation: none; } }
</style>
